<template>
  <section class="monthly-car-renewal">
    <section class="go-back" @click="onGoBackbtn">&lt;返回</section>
    <section class="monthly-car-renewal-content">
      <el-form
        class="monthly-car-renewal-form"
        ref="rentMonthForm"
        :model="monthlyFormOrder"
        label-width="80px"
        :rules="rentMonthRules"
      >
        <el-form-item label="续费日期" prop="openDate" class="reset-input">
          <el-date-picker
            v-model="monthlyFormOrder.openDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="续费月数" prop="openMonth">
          <el-input v-model.number="monthlyFormOrder.openMonth"></el-input>
        </el-form-item>
        <el-form-item label="收费规则" prop="openCharge" class="reset-input">
          <el-select
            clearable
            v-model="monthlyFormOrder.openCharge"
            placeholder="请选择"
          >
            <el-option
              v-for="item in allMonthlyChargeRuleData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="道路名称" prop="parkings" class="reset-input">
          <el-select
            multiple
            clearable
            v-model="monthlyFormOrder.parkings"
            placeholder="请选择"
          >
            <el-option
              v-for="item in parkingsDataByProperty"
              :key="item.parkingId"
              :label="item.parkingName"
              :value="item.parkingId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <section class="buttons">
        <el-button class="cash-button" type="primary" @click="onCashBtn"
          >现金付款</el-button
        >
        <el-button class="qrcode-button" type="primary" @click="onQrcodeBtn"
          >扫码付款</el-button
        >
      </section>
    </section>
    <!--付款二维码-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        title="扫码付款"
        :visible.sync="photoDialogVisible"
        width="400px"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <div id="qrcode"></div>
        <div class="qrcode-money">应缴金额：{{ monthlyMoney }}</div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { ref, defineComponent } from "@vue/composition-api";
import {
  monthlyUserAddOrEdit,
  allMonthlyChargeRule,
  getParkingsByProperty,
} from "@/api/url";
// interface MonthlyOrder{
// openDate:String,
// openMonth:Number,
// openCharge:String,
// parkings:String[],

// }

import QRCode from "qrcodejs2"; // 引入qrcode
const currency=require('currency.js')
export default {
  created() {
    console.log(this.$route);
    this.recordId = this.$route.query.recordId;
    this.road = this.$route.query.road;
  },
  mounted() {
    const road =
      road && typeof JSON.parse(road) === "object" && JSON.parse(this.road);
    this.getAllMonthlyChargeRule(road?.id);
    this.reqParkingsByProperty(road?.id);
  },
  data() {
    return{
     recordId :"",
    parent:"{}",
    photoDialogVisible:false,
    allMonthlyChargeRuleData:[],
    parkingsDataByProperty:[],
    monthlyMoney:0.0,
    monthlyFormOrder:{
      id: "",
      openDate: "",
      openMonth: "",
      openCharge: "",

      parkings: [],
    },
    rentMonthRules:{
      openDate: [
        {
          required: true,
          trigger: ["blur", "change"],
          message: "请选择开通日期",
        },
      ],
      openMonth: [
        { required: true, message: "请填写开通月数", trigger: "blur" },
          { type: 'number', message: '续费月数必须为数字值'}
      ],
      openCharge: [
        {
          required: true,
          message: "请选择收费规则",
          trigger: ["blur", "change"],
        },
      ],
      parkings: [
        {
          required: true,
          message: "请选择道路",
          trigger: ["blur", "change"],
        },
      ],
    }
    }
    
  },
  methods:{
    getAllMonthlyChargeRule(id) {
      this.$get(allMonthlyChargeRule(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) return;
        this.allMonthlyChargeRuleData = data.data;
      });
    },
    reqParkingsByProperty(id) {
      this.$get(getParkingsByProperty(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) {
          return;
        }
        this.parkingsDataByProperty = data?.data ?? {};
      });
    },
    valiForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(function(valid, noStri) {
          if (valid) {
            resolve({ status: true });
          } else {
            reject({ status: false, msg: "表单验证失败" });
          }
        });
      });
    },
    onGoBackbtn() {
      this.$router.go(-1);
    },
    async onCashBtn() {
      try {
        await this.valiForm("rentMonthForm");
        const chargeRule = this.allMonthlyChargeRuleData.find(
          (rule) => rule.id === this.monthlyFormOrder.openCharge
        );
        const money = currency(this.monthlyFormOrder.openMonth).multiply(chargeRule.amount);
        await this.$confirm(`现金缴费金额为${money},确认缴费请按确定。`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const monthlyData = await this.$postRequest(monthlyUserAddOrEdit(), {
          id: this.recordId,
          months: this.monthlyFormOrder.openMonth,
          startTime: this.monthlyFormOrder.openDate,
          chargeRuleId: this.monthlyFormOrder.openCharge,
          parkingIds: this.monthlyFormOrder.parkings,
          cashAmount:money
        });
        monthlyData?.status == 200
          ? (() => {
              this.$message({
                message: "缴费成功",
                type: "success",
              });
            })()
          : (() => {
              this.$message({
                message: "缴费失败",
                type: "warning",
              });
            })();
      } catch (err) {
        this.$message({
          type: "warning",
          message: err,
        });
      }
    },
    async onQrcodeBtn() {
      try {
        await this.valiForm("rentMonthForm");
        const chargeRule = this.allMonthlyChargeRuleData.find(
          (rule) => rule.id === this.monthlyFormOrder.openCharge
        );
        this.monthlyMoney =currency(this.monthlyFormOrder.openMonth).multiply(chargeRule.amount) ;
        const monthlyData = await this.$postRequest(monthlyUserAddOrEdit(), {
          id: this.recordId,
          months: this.monthlyFormOrder.openMonth,
          startTime: this.monthlyFormOrder.openDate,
          chargeRuleId: this.monthlyFormOrder.openCharge,
          parkingIds: this.monthlyFormOrder.parkings,
          cashAmount:this.monthlyMoney
        });
        if (monthlyData?.status != 200) return;
        this.photoDialogVisible = true;
        this.$nextTick(() => {
          document.getElementById("qrcode").innerHTML = "";

          this.qrcode(monthlyData?.data);
        });
      } catch (err) {
        this.$message({
          type: "warning",
          message: err,
        });
      }
    },
   qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 360,
        height: 360,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
    }
 

  }
    
}
</script>
<style scoped>
.monthly-car-renewal {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  padding-left: 20px;
  display: flex;
  justify-content: center;
  overflow: auto;
}
.go-back {
  font-size: 20px;
  cursor: pointer;
}
.monthly-car-renewal-content {
  width: 80%;
  margin-top: 100px;
}
.monthly-car-renewal-form {
  width: 100%;
}
.buttons {
  margin-top: 100px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.cash-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
.qrcode-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
</style>
<style>
.monthly-car-renewal .el-form-item {
  height: 50px;
  margin-top: 40px;
}
.monthly-car-renewal .el-form-item__content {
  height: 100%;
}
.monthly-car-renewal .el-date-editor.el-input,
.monthly-car-renewal .el-date-editor.el-input__inner {
  width: 100%;
  max-width: 100%;
  height: 100%;
}
.monthly-car-renewal .el-select {
  width: 100%;
  max-width: 100%;
}
.monthly-car-renewal .el-input__inner,
.monthly-car-renewal .el-input,
.monthly-car-renewal .el-select {
  height: 100%;
  border-radius: 10px;
}
.qrcode-money {
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}
</style>
